import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import axios from "axios";
import { Lazyload, Toast, Dialog } from "vant";
import "./less/main.less";
import WechatAuth, { ScopeType } from "@/components/wechat/wechatAuth";
import { Component } from "vue-property-decorator";
import { env } from "@/env";
Vue.config.productionTip = false;
Vue.use(Lazyload, {
  lazyComponent: true,
});
Vue.use(Toast);
Vue.use(Dialog);
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);

const wechatConfig = {
  appId: env.VUE_APP_WX_API_ID as string,
  scope: "snsapi_userinfo" as ScopeType,
  authorize: (code: string) =>
    axios.get(env.VUE_APP_URL + "/weixinmp/wlogin", {
      params: { code },
    }),
};

if (env.VUE_APP_WX_AGENT_ID) {
  Object.assign(wechatConfig, {
    appId: env.VUE_APP_WX_CORP_ID as string,
    agentid: env.VUE_APP_WX_AGENT_ID as string,
    authorize: (code: string) =>
      axios.get(env.VUE_APP_URL + "/weixincp/wlogin", {
        params: { code },
      }),
  });
}

export const wechatAuth: WechatAuth = new WechatAuth(wechatConfig);

router.beforeEach((to, from, next) => {
  wechatAuth.routerBeforeGuards(to, from, next);
});

const mainVue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
// for debug we can use mainVue in Console
(window as any).mainVue = mainVue;
